<div layout layout-align-items-center>
  <rt-button variant="tertiary" (click)="selected.emit(Type.FILE)" margin-right-medium>
    <rt-icon name="file-upload" />
    {{ 'app.candidate.upload_file' | translate }}
  </rt-button>
  <span>{{ 'app.common.or' | translate }}</span>
  <rt-button variant="tertiary" (click)="selected.emit(Type.TEXT)" margin-left-medium>
    <rt-icon name="format-align-left" />
    {{ 'app.candidate.enter_text' | translate }}
  </rt-button>
</div>
